import { CalendarAdd, CalendarCheck } from '@griply/assets';
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { CalendarSyncMenu } from 'shared/components/ui/calendar-sync-menu';
import { Colors } from 'shared/components/ui/checkbox';
import { Icon } from 'shared/components/ui/icon';
import { useOpenMenu } from 'shared/hooks/use-open-menu';

import * as Styled from './calendar-event-sync-badge.style';

export type CalendarEventSyncBadgeProps = {
  isSynced: boolean;
  isHidden: boolean;
  onToggleSync: () => void;
  onToggleVisibility: () => void;
  // The card's checkbox color, so the badge matches its border.
  color?: Colors | string;
};

export const CalendarEventSyncBadge: React.FC<CalendarEventSyncBadgeProps> = ({
  isSynced,
  isHidden,
  onToggleSync,
  onToggleVisibility,
  color,
}) => {
  const { t } = useTranslation();
  const buttonRef = useRef<HTMLButtonElement>(null);
  const { menuOpen, openMenu, closeMenu } = useOpenMenu();

  const onBadgeClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    openMenu();
  };

  return (
    <>
      <Styled.Badge
        ref={buttonRef}
        type="button"
        onClick={onBadgeClick}
        aria-label={t('calendar.event-sync.aria-label')}
        $synced={isSynced}
        $color={color}
      >
        <Icon
          icon={isSynced ? CalendarCheck : CalendarAdd}
          size={12}
          strokeWidth={2}
        />
      </Styled.Badge>

      {menuOpen && (
        <CalendarSyncMenu
          isSynced={isSynced}
          isHidden={isHidden}
          onToggleSync={onToggleSync}
          onToggleVisibility={onToggleVisibility}
          onClose={closeMenu}
          referenceElement={buttonRef}
        />
      )}
    </>
  );
};
